import React from 'react';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-semibold text-white mb-3">{title}</h2>
    <div className="text-gray-400 text-sm leading-relaxed space-y-2">{children}</div>
  </div>
);

const Privacy = () => (
  <div className="min-h-screen py-16 px-6">
    <div className="max-w-3xl mx-auto">
      <h1 className="text-4xl font-bold text-white mb-2">Privacy Policy</h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: April 14, 2026</p>

      <Section title="1. Who We Are">
        <p>globalnow.biz ("we", "us", "our") is an AI-powered website builder for small businesses,
        operated by Brent Bozeman. Contact: support@globalnow.biz</p>
      </Section>

      <Section title="2. What We Collect">
        <p><strong className="text-gray-300">Account data:</strong> name and email address when you sign up.</p>
        <p><strong className="text-gray-300">Payment data:</strong> payments are processed by PayPal. We do not store your credit card number or full payment details — PayPal handles that directly.</p>
        <p><strong className="text-gray-300">Usage data:</strong> websites you generate, content you create, and AI chat sessions. This is used to deliver the service and improve it.</p>
        <p><strong className="text-gray-300">Waitlist data:</strong> if you join our mailing list, we store your name and email to send you product updates.</p>
        <p><strong className="text-gray-300">Analytics:</strong> we use PostHog for anonymous usage analytics to understand how the product is used.</p>
      </Section>

      <Section title="3. How We Use Your Data">
        <p>• To create and manage your account</p>
        <p>• To deliver the services you purchased</p>
        <p>• To send transactional emails (payment receipts, account notices)</p>
        <p>• To send product updates if you opted into our mailing list (unsubscribe any time)</p>
        <p>• To improve our platform based on usage patterns</p>
      </Section>

      <Section title="4. AI-Generated Content">
        <p>Content you generate using our AI tools (websites, blog posts, scripts) belongs to you.
        We do not claim ownership of your generated content. We may use anonymized, aggregated
        generation data to improve our AI models.</p>
      </Section>

      <Section title="5. Data Sharing">
        <p>We do not sell your personal data. We share data only with:</p>
        <p>• <strong className="text-gray-300">Supabase</strong> — authentication and database hosting</p>
        <p>• <strong className="text-gray-300">PayPal</strong> — payment processing</p>
        <p>• <strong className="text-gray-300">Netlify</strong> — frontend hosting</p>
        <p>• <strong className="text-gray-300">OpenAI / Groq</strong> — AI generation (your prompts may be processed by these providers per their own privacy policies)</p>
      </Section>

      <Section title="6. Data Retention">
        <p>We retain your account data for as long as your account is active. You may request deletion
        of your account and associated data at any time by emailing support@globalnow.biz.</p>
      </Section>

      <Section title="7. Cookies">
        <p>We use essential cookies for authentication (keeping you logged in) and analytics cookies
        via PostHog. You can disable cookies in your browser settings, though some features may
        not work correctly without them.</p>
      </Section>

      <Section title="8. Your Rights">
        <p>You have the right to access, correct, or delete your personal data. Email us at
        support@globalnow.biz and we will respond within 30 days.</p>
      </Section>

      <Section title="9. Security">
        <p>We use industry-standard security practices including encrypted connections (HTTPS),
        secure authentication via Supabase, and do not store payment card data. No system is
        100% secure — if you discover a vulnerability, please contact us immediately.</p>
      </Section>

      <Section title="10. Changes to This Policy">
        <p>We may update this policy as the product evolves. We will notify registered users of
        material changes by email. Continued use of the service after changes constitutes
        acceptance of the updated policy.</p>
      </Section>

      <Section title="11. Contact">
        <p>Questions about this policy? Email us at <a href="mailto:support@globalnow.biz" className="text-blue-400 hover:underline">support@globalnow.biz</a></p>
      </Section>
    </div>
  </div>
);

export default Privacy;
